import PropTypes from 'prop-types';
import UserShape from './UserShape';

const VerificationEntryShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  expiredAt: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  post: PropTypes.object,
  verifiedAt: PropTypes.string,
  verifier: UserShape,
});

export default VerificationEntryShape;
